import base62 from 'uuid-base62';
import React, { Fragment, useContext, useState } from 'react';
import { withStyles, Divider, Grid } from '@material-ui/core';
import Carousel from '../../carousel/Carousel';
import CarouselEmbla from '../../carousel/CarouselEmbla';
import DataContext from '../../data/DataContext';
import {
  smileRetrieveSeVisitPossibleDate,
  SFDCRetrieveSeVisitPossibleDate,
} from '../../data/DataLoader';
// import LP from "./LP";
import ReserveCancel from '../../modal/ReserveCancel';
import ReserveUpdate from '../../modal/ReserveUpdate';
// 서비스매니저 메시지 전송 기능 추가 24-05
import CustUrge from '../../modal/CustUrge';
import Engineer from '../../../asset/img/img_profile_default.png';
import IconShare from '../../../asset/img/icon_share.svg';
import LoadingAni from '../../../asset/img/loading.json';
import LoadingAni2 from '../../../asset/img/loading2.json';
import Lottie from 'lottie-react';
import { openLink } from '../../util/utilNative';

const styles = (theme) => ({
  root: {
    position: 'relative',
    letterSpacing: '-0.0313rem',
    margin: '0.375rem 0rem',
    zIndex: 10,
    paddingBottom: '4.375rem',
  },
  carousel: {
    width: '100%',
    height: 'auto',
  },
  item: {
    height: '2.3125rem',
    textAlign: 'center',
    color: theme.color.select.color,
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    padding: '0 1rem',
    flex: 1,
  },
  titleRow: {
    margin: '0 0 1.0938rem 0',
  },
  vertical: {
    height: 'auto',
  },
  list: {
    display: 'flex',
    margin: '0rem 1.25rem 0rem 1.25rem',
  },
  listitem: {
    maxWidth: '16.75rem',
    padding: '0rem 0.5rem 0rem 0rem',
  },
  card: {
    width: '16.25rem',
    height: '100%',
    flex: 'auto',
    // background: "#fff",
    // border: `1px solid ${theme.color.list_divider}`,
    // borderRadius: "12px",
    textAlign: 'start',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  cardTitle: {
    fontSize: theme.font.size15, // "15px",
    fontWeight: 'bold',
    color: theme.color.text_color.black,
    width: '100%',
    textAlign: 'start',
    // marginBottom: "8px",
  },
  shareIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  thumbnail: {
    height: '8.125rem',
    padding: '0.9375rem 1.1875rem 0.75rem',
  },
  thumbnailImage: {
    width: 'auto',
    height: '6.4375rem',
  },
  info: {
    minHeight: '20.625rem',
    padding: '1.0625rem 1rem 0 1rem',
    borderRadius: '0.375rem 0.375rem 0 0',
    background: theme.color.message.background_white,
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.1)',
    flex: 1,
    // border: `1px solid ${theme.color.list_divider}`,
    // height: "100%",
  },
  infoTop: {
    // marginBottom: "16px",
    margin: '0.7188rem 0',
  },
  infoTitle: {
    fontSize: theme.font.size12, // "15px",
    fontWeight: 'bold',
    color: theme.color.text_color.black,
    marginBottom: '0.125rem',
  },
  infoDesc: {
    fontSize: theme.font.size12, // "15px",
    margin: '0.125rem 0',
  },
  infoDescKey: {
    textAlign: 'left',
    color: theme.color.text_color.grey,
  },
  infoDescValue: {
    textAlign: 'right',
    color: theme.color.text_color.black,
  },
  external: {
    display: 'flex',
    height: '2.8125rem',
    background: '#f7f0f0',
    borderRadius: '0 0 0.375rem 0.375rem',
    borderTop: '0.0625rem solid #d7d7d7',
    marginTop: '0.625rem',
  },
  externalButton: {
    color: '#555',
    fontWeight: 'bold',
    fontSize: theme.font.size14,
    flex: 1,
    border: 'none',
    padding: 0,
    background: 'transparent',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  buttonBox: {
    margin: '0',
    // padding: "0 16px",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#fff',
    borderRadius: '0 0 0.375rem 0.375rem',
    padding: '0 1rem 1rem 1rem',
  },
  button: {
    width: '100%',
    margin: '0.375rem 0 0 0',
    height: '2.875rem',
    fontWeight: 'bold',
    fontSize: theme.font.size14,
    lineHeight: '1.54',
    // outline: '0 none',
    border: 'none',
    borderRadius: '0.375rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // "&:active": {
    //   backgroundColor: "rgba(38, 38, 38, 0.1)",
    // },
  },
  buttonFirst: {
    background: theme.color.button.background_red,
    color: theme.color.button.text_white,
  },
  buttonNormal: {
    background: theme.color.button.background_grey,
    color: theme.color.button.text_black,
    border: 'none',
  },
  buttonDisabled: {
    // color: "rgba(38, 38, 38, 0.4)",
    backgroundColor: theme.color.button.background_red_disable,
    color: theme.color.button.text_white_disable,
  },
  engimg: {
    width: '4.6875rem',
    height: '100px',
    marginTop: '0.25rem',
    border: `0.0625rem solid ${theme.color.list_divider}`,
  },
  divider: {
    height: '0.0625rem',
    backgroundColor: theme.color.list_divider,
  },
  topDivider: {
    margin: '0 0 0.25rem 0',
  },
  redButton: {
    color: theme.color.button.rbut_text,
    backgroundColor: theme.color.button.rbut_bg,
    border: '0',
  },
  redButtonDisable: {
    color: theme.color.button.rbut_text_disable,
    backgroundColor: theme.color.button.rbut_bg_disable,
    border: '0',
  },
  whiteButton: {
    color: theme.color.button.wbut_text,
    backgroundColor: theme.color.button.wbut_bg,
    border: `solid 0.0625rem ${theme.color.button.wbut_border}`,
  },
  whiteButtonDisable: {
    color: theme.color.button.wbut_text_disable,
    backgroundColor: theme.color.button.wbut_bg_disable,
    // border: `solid 0.0625rem ${theme.color.button.wbut_border_disable}`
  },
  animationBody: {
    /*
    position: "absolute",
    margin: "auto",
    top: "0",
    left: "0",
    bottom: "0",
    right: "0",
    width: "50%",
    height: "50%"
    */
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    height: '100%',
    // backgroundColor: "#ddd"
  },
  loadingAnimation: {
    backgroundColor: 'transparent',
    // zIndex:10,
    width: '5rem',
    height: '2.5rem',
    cursor: 'pointer',
  },
  oneCardBox: {
    margin: '0 1rem',
    maxWidth: '16.25rem',
  },
});

// const cancelPopupData = {
//   title: "예약 취소",
//   description: "예약 취소 접수 진행을 위해 사유를 선택해주세요.",
//   list_items: [
//     {
//       label: "서비스 신청 후 제품 정상 가동",
//     },
//     {
//       label: "시간이 맞지 않거나 다음에 다시 신청",
//     },
//     {
//       label: "신제품 구매 예정",
//     },
//     {
//       label: "직접 해결 시도(수리/이전설치 등)",
//     },
//     {
//       label: "기타",
//     },
//   ],
//   buttons: [
//     { label: "취소", type: "cancel" },
//     { label: "확인", type: "confirm" },
//   ],
// };
const animationOpt = {
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  loop: true,
  animationData: LoadingAni,
};

async function getSeVisitPossibleDate(context, is_hirun, dataObj) {
  let result = null;

  if (context.isSFDC) {
    if (is_hirun && is_hirun === 'yes') {
      result = await smileRetrieveSeVisitPossibleDate(
        context,
        dataObj.zipId,
        dataObj.productCode,
        dataObj.premiumYn,
        dataObj.custName,
        dataObj.tel1,
        dataObj.tel2,
        dataObj.tel3,
        dataObj.rcptSympCode,
        dataObj.rcptSubSympCode,
        dataObj.purpose,
        // dataObj.installType, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
        // dataObj.contactRating, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
        is_hirun
      );
    } else {
      // 무인채널접수 우선T/T제공 (예약변경) 24-05
      result = await SFDCRetrieveSeVisitPossibleDate(
        context,
        dataObj.zipNo,
        dataObj.zipId,
        dataObj.productCode,
        dataObj.svcType,
        dataObj.custName,
        dataObj.tel1,
        dataObj.tel2,
        dataObj.tel3,
        dataObj.rcptSubSympCode,
        dataObj.rcptSympCode,
        dataObj.rcptFurtherSubSympCode,
        dataObj.rcptUserId,
        dataObj.modelCode,
        dataObj.installType, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
        dataObj.contactRating // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
      );
    }
  } else {
    result = await smileRetrieveSeVisitPossibleDate(
      context,
      dataObj.zipId,
      dataObj.productCode,
      dataObj.premiumYn,
      dataObj.custName,
      dataObj.tel1,
      dataObj.tel2,
      dataObj.tel3,
      dataObj.rcptSympCode,
      dataObj.rcptSubSympCode,
      dataObj.purpose,
      // dataObj.installType, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
      // dataObj.contactRating, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
      is_hirun
    );
  }

  return result;
}

const InnerCard = (props) => {
  const { classes, item, key, parentFunc, parentVal } = props;

  const isLoading = parentVal.isLoading;
  const context = useContext(DataContext);
  return (
    <>
      <div className={classes.info}>
        <Grid container className={classes.titleRow}>
          <Grid item xs={12}>
            <div className={classes.cardTitle}>{item.title}</div>
          </Grid>
          {/* 230515 minseok.seo 유창혜주임 시나리오 수정 - TICard 공유 삭제 */}
          {/* <Grid item xs={(context.userAgent.deviceType === "mobile")?6:12}><div className={classes.cardTitle}>{item.title}</div></Grid>
              {(context.userAgent.deviceType === "mobile")&&(
                <Grid xs={6} item className={classes.shareIcon}>
                  <img onClick={()=>{
                    if (window.navigator.share) {
                      let shareUrl = `https://www.lge.co.kr`
                      window.navigator.share({
                        title: "",
                        url: shareUrl 
                      }).then(() => {
                        console.log('Thanks for sharing!');
                      })
                      .catch(console.error);
                    } else {
                      console.log("not supported device for share api")
                    }
                  }} src={IconShare}/>
                </Grid>
              )} */}
        </Grid>
        {item.list_items.map((list_item, index) => (
          <Fragment key={`list_item-${index}`}>
            <Divider
              className={[classes.divider, classes.topDivider].join(' ')}
              component={'div'}
            />
            <div key={`list_item_${index}`} className={classes.infoTop}>
              <div className={classes.infoTitle}>{list_item.sub_title}</div>
              {list_item.sub_items.map((subItem, subItemIndex) => (
                <Grid
                  container
                  key={`${subItem.key}-${subItemIndex}`}
                  className={classes.infoDesc}
                  role={'text'}
                >
                  <Grid item xs={4} className={classes.infoDescKey}>
                    {subItem.key}
                  </Grid>
                  <Grid item xs={8} className={classes.infoDescValue}>
                    {subItem.value}
                  </Grid>
                </Grid>
              ))}
              {/* {index === 0 &&
                    item.meta &&
                    item.meta.picture_yn &&
                    item.meta.picture_yn !== "NA" && (
                      <img
                        className={classes.engimg}
                        src={
                          item.meta &&
                          item.meta.picture_yn &&
                          item.meta.picture_yn.toUpperCase() === "Y"
                            ? `https://www.lge.co.kr/support/downImageFile?value=/upload/engimg/${item.meta.se_id}.jpg`
                            : Engineer
                        }
                        alt={""}
                      />
                    )} */}
            </div>
          </Fragment>
        ))}
      </div>

      {/* <Divider className={classes.divider} component={"div"} disabled /> */}
      <div className={classes.buttonBox}>
        {item.buttons.map((button, index) => (
          <button
            key={`item_button_${index}`}
            type="button"
            className={[
              classes.button,
              isLoading || button.enable === 'N' || context.conversationEnd
                ? index === 0
                  ? classes.redButtonDisable
                  : classes.whiteButtonDisable
                : index === 0
                ? classes.buttonFirst
                : classes.buttonNormal,
            ].join(' ')}
            disabled={isLoading || button.enable === 'N' || context.conversationEnd}
            onClick={() => {
              if (button.parameters.action === 'modal') {
                parentFunc.onButtonClick(button?.parameters?.modal?.type, item, button);
              } else {
                parentFunc.onButtonClick('external', item, button);
              }
            }}
          >
            {/* {isLoading ? (<Lottie
                {...animationOpt}
                className={classes.loadingAnimation}
                width={"5rem"}
                height={"2.5rem"}
              />) : button.label} */}
            {button.label}
          </button>
        ))}
      </div>
    </>
  );
};

const CardList = (props) => {
  const { classes, data, parentFunc, parentVal } = props;

  const isLoading = parentVal.isLoading;
  const context = useContext(DataContext);
  return data.items.map((item, key) => (
    <Fragment key={`ticard_${key}`}>
      <div key={key} className={classes.listitem}>
        <div className={classes.card}>
          <InnerCard {...props} item={item} key={key} />
        </div>
      </div>
    </Fragment>
  ));
};

const OneCard = (props) => {
  const { classes, data, parentFunc, parentVal } = props;
  return (
    <div className={classes.oneCardBox}>
      <InnerCard
        classes={classes}
        data={data}
        item={data.items[0]}
        key={0}
        parentFunc={parentFunc}
        parentVal={parentVal}
      />
    </div>
  );
};

function TICard(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const [openCancel, setOpenCancel] = useState(false);
  const [openReserveUpdate, setOpenReserveUpdate] = useState(false);
  const [reserveCancelData, setReserveCancelData] = useState(null);
  const [reserveUpdateData, setReserveUpdateData] = useState(null);
  const [possibleDate, setPossibleDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // 서비스매니저 메시지 전송 기능 추가 24-05
  const [openCustUrge, setOpenCustUrge] = useState(false);
  const [custUrgeData, setCustUrgeData] = useState(null);

  const handleButtonClick = async (type, item, button) => {
    if (type == 'book_cancel') {
      const cancelYn = item.meta.cancel_yn;
      if (cancelYn.toUpperCase() === 'Y') {
        setReserveCancelData({ item, button });
        setOpenCancel(true);

        const rootChild = document.getElementById('root');
        const focusableElements = rootChild.querySelectorAll('*');

        for (let i = 0; i < focusableElements.length; i++) {
          focusableElements[i].setAttribute('aria-hidden', 'true');
        }
      } else {
        // context.addTLMessage(false, context.string.chat.noncancelable, [
        //   { type: "external", url: "tel:15447777", label: "전화걸기" },
        // ]);
        context.addSGMessage(
          false,
          context.string.chat.noncancelable,
          [
            {
              speech: '고객서비스 상담사 채팅',
            },
          ],
          false
        );
      }
    } else if (type === 'book_update') {
      console.log('book_update clicked::ITEM', item);
      console.log('book_update clicked::button', button);

      let requestObj = {};

      // 무인채널접수 우선T/T제공 (예약변경) 24-05
      requestObj = {
        zipId: item.meta.zipId,
        productCode: item.meta?.productCode,
        premiumYn: item.meta?.premium || 'N',
        custName: item.meta.custName, // 고객이름 	선택	시그니처 T/T
        tel1: button.parameters?.modal?.data?.telNo1_1,
        tel2: button.parameters?.modal?.data?.telNo1_2,
        tel3: button.parameters?.modal?.data?.telNo1_3,
        rcptSympCode: item.meta.rcptSympCode, // string	증상코드 (1depth)	선택	가전세척 불필요
        rcptSubSympCode: item.meta.rcptSubSympCode, // string	증상분류코드 (2depth)	선택	가전세척 불필요
        rcptFurtherSubSympCode: item.meta.rcptFurtherSubSympCode, // string	상세 증상코드 (3depth)	선택	가전세척 불필요
        purpose: item.meta.purpose,
        zipNo: item.meta?.zipNo,
        svcType: item.meta?.svcType,
        rcptUserId: item.meta.rcptUserId, // WWW3 PC 접근 (LGE.COM) | WWW4 모바일 접근 (LGE.COM)
        modelCode: item.meta?.modelCode || '', // 고객입력한 모델
        installType: item.meta?.installType || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
        contactRating: item.meta?.contactRating || '', // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
      };

      const is_hirun = item.meta?.is_hirun || null;
      setIsLoading(true);
      let result = await getSeVisitPossibleDate(context, is_hirun, requestObj);
      setIsLoading(false);
      console.log(result);
      if (!('error' in result.result)) {
        if (context.isSFDC) {
          if (is_hirun && is_hirun === 'yes') {
            setPossibleDate(result.result.possibleDate);
          } else {
            setPossibleDate(result.result);
          }
        } else {
          setPossibleDate(result.result.possibleDate);
        }

        setReserveUpdateData({
          button: button,
          modalValue: null,
          hirunVal: is_hirun && is_hirun === 'yes',
          item: item,
        });
        setOpenReserveUpdate(true);

        const rootChild = document.getElementById('root');
        const focusableElements = rootChild.querySelectorAll('*');

        for (let i = 0; i < focusableElements.length; i++) {
          focusableElements[i].setAttribute('aria-hidden', 'true');
        }
      } else {
        const buttonParameters = button.parameters.parameters;
        const buttonExpect = button.parameters.expect;
        let byPassBrObj = { bypass_br: 'change_na' };
        context.request(
          context,
          buttonParameters?.speech || '',
          'button',
          {
            ...buttonParameters,
            ...byPassBrObj,
          },
          buttonExpect || {
            mode: 'bypass',
            intent: 'THQ_BOOK_CHANGE',
          }
        );
      }
    } else if (type === 'cust_urge') {
      // 서비스매니저 메시지 전송 기능 추가 24-05
      console.log('cust_urge clicked::ITEM', item);
      console.log('cust_urge clicked::button', button);

      setCustUrgeData({ item, button });
      setOpenCustUrge(true);

      const rootChild = document.getElementById('root');
      const focusableElements = rootChild.querySelectorAll('*');

      for (let i = 0; i < focusableElements.length; i++) {
        focusableElements[i].setAttribute('aria-hidden', 'true');
      }
    } else {
      const url =
        context.userAgent.deviceType === 'mobile'
          ? button.parameters.mobile_url
          : button.parameters.url;
      openLink(context, button.parameters.action, url);
    }
  };

  // 서비스매니저 메시지 전송 기능 추가 24-05
  const handleCustUrgeClick = async (confirm, label, item, button, modalLabel) => {
    console.log('[handleCustUrgeClick] confirm', confirm);
    console.log('[handleCustUrgeClick] label', label);
    console.log('[handleCustUrgeClick] item.meta', item.meta);
    console.log('[handleCustUrgeClick] button', button);
    console.log('[handleCustUrgeClick] modalLabel', modalLabel);

    let today = new Date();
    let time = {
      year: today.getFullYear(),
      month: (today.getMonth() + 1 < 10 ? '0' : '') + (today.getMonth() + 1),
      date: (today.getDate() < 10 ? '0' : '') + today.getDate(),
      hours: (today.getHours() < 10 ? '0' : '') + today.getHours(),
      minutes: (today.getMinutes() < 10 ? '0' : '') + today.getMinutes(),
      seconds: (today.getSeconds() < 10 ? '0' : '') + today.getSeconds(),
    };

    let timeString = `${time.year}-${time.month}-${time.date} ${time.hours}:${time.minutes}:${time.seconds}`;

    // const params = item.meta;
    const buttonExpect = button.parameters.expect;
    const buttonParamsRcptNo = button.parameters.modal.data.rcptNo;
    const expectDefault = {
      mode: 'bypass',
      intent: 'CUST_URGE_BYPASS',
    };
    const confirmData = {
      rcptNo: buttonParamsRcptNo,
      rcptUserId: context.userAgent.deviceType === 'mobile' ? 'WWW4' : 'WWW3',
      urgeDesc: `고객 전달 | LGE.COM Chatbot | ${timeString} | ${label}`,
      bypass_br: 'urge',
    };
    const cancelData = {
      bypass_br: 'cancel',
    };
    if (confirm) {
      context.request(
        context,
        modalLabel,
        'button',
        confirmData,
        buttonExpect || expectDefault
      );
    } else {
      context.request(
        context,
        modalLabel,
        'button',
        cancelData,
        buttonExpect || expectDefault
      );
    }
    setOpenCustUrge(false);

    console.log('[handleCustUrgeClick] PARAMS', label ? confirmData : cancelData);
  };

  // const handlePopupClick = async (button, label, item) => {
  const handlePopupClick = async (confirm, label, item, button, modalLabel) => {
    console.log('handlePopupClick', confirm, label, item, button);
    const buttonParameters = button.parameters.parameters;
    const buttonExpect = button.parameters.expect;
    const expectDefault = {
      mode: 'bypass',
      intent: 'THQ_BOOK_CHECK',
    };
    if (confirm) {
      context.request(
        context,
        buttonParameters?.speech || modalLabel,
        'button',
        {
          ...buttonParameters,
          svcType: item.meta.svc_type,
          rcptNo: item.meta.rcpt_no,
          custName: item.meta.custName,
          cancelDesc: label,
          cancelUserId: context.userAgent.deviceType === 'mobile' ? 'WWW4' : 'WWW3',
          is_hirun: item.meta.is_hirun,
          bypass_br: 'book_cancel',
        },
        buttonExpect || expectDefault
      );
    } else {
      context.request(
        context,
        buttonParameters?.speech || modalLabel,
        'button',
        {
          ...buttonParameters,
          rcptNo: item.meta.rcpt_no,
          user_name: item.meta.custName,
          bypass_br: 'cancel',
        },
        buttonExpect || expectDefault
      );
    }
    setOpenCancel(false);
  };

  const parentFunc = {
    onButtonClick: handleButtonClick,
  };
  const parentVal = {
    isLoading,
  };

  const options = {
    align: 'start',
    dragFree: false,
    containScroll: true,
    // speed: 8,
    loop: false,
  };

  return (
    <>
      <div className={classes.root}>
        {data.items.length > 1 ? (
          <CarouselEmbla
            className={classes.carousel}
            component={withStyles(styles)(CardList)}
            data={data}
            parentFunc={parentFunc}
            parentVal={parentVal}
            ariaLabel={context.string.aria.reserve}
            options={options}
            autoplay={false}
            arrowsTI={true}
            indicator={false}
          />
        ) : (
          // <Carousel
          //   className={classes.carousel}
          //   component={withStyles(styles)(CardList)}
          //   data={data}
          //   parentFunc={parentFunc}
          //   parentVal={parentVal}
          //   ariaLabel={context.string.aria.reserve}
          //   arrows={true}
          //   indicator={false}
          // />
          data.items.length === 1 && (
            <OneCard
              classes={classes}
              data={data}
              parentFunc={parentFunc}
              parentVal={parentVal}
            />
          )
        )}
      </div>
      {openCancel && (
        <ReserveCancel
          data={reserveCancelData}
          modalOpen={openCancel}
          modalClose={() => {
            setOpenCancel(false);
            const rootChild = document.getElementById('root');
            const focusableElements = rootChild.querySelectorAll('*');

            for (let i = 0; i < focusableElements.length; i++) {
              focusableElements[i].removeAttribute('aria-hidden');
            }
          }}
          handleButtonClick={handlePopupClick}
        />
      )}
      {openReserveUpdate && (
        <ReserveUpdate
          possibleDate={possibleDate}
          data={{
            modalValue: null,
            button: reserveUpdateData.button,
            installType: reserveUpdateData.item.meta?.installType || '',
            contactRating: reserveUpdateData.item.meta?.contactRating || '',
          }}
          modalOpen={openReserveUpdate}
          // basicInfo={reserveUpdateData.basicInfo}
          // completeClose = {completeClose}
          hirunVal={reserveUpdateData.hirunVal}
          modalClose={() => {
            setOpenReserveUpdate(false);
            const rootChild = document.getElementById('root');
            const focusableElements = rootChild.querySelectorAll('*');

            for (let i = 0; i < focusableElements.length; i++) {
              focusableElements[i].removeAttribute('aria-hidden');
            }
          }}
        />
      )}

      {/* 서비스매니저 메시지 전송 기능 추가 24-05 */}
      {openCustUrge && (
        <CustUrge
          data={custUrgeData}
          modalOpen={openCustUrge}
          modalClose={() => {
            setOpenCustUrge(false);
            const rootChild = document.getElementById('root');
            const focusableElements = rootChild.querySelectorAll('*');

            for (let i = 0; i < focusableElements.length; i++) {
              focusableElements[i].removeAttribute('aria-hidden');
            }
          }}
          handleButtonClick={handleCustUrgeClick}
        />
      )}

      {/* <LP
        open={openCancel}
        data={cancelPopupData}
        item={item}
        handleButtonClick={handlePopupClick}
      /> */}
    </>
  );
}
export default withStyles(styles)(TICard);
